module.exports = __webpack_public_path__ + "img/successInfo.88fdc69c.png";